export default { "none":"Ninguno", "send":"ENVIAR", "sendMessage":"ENVIAR MENSAJE", "sending":"ENVIANDO..." } as const;
